// ENRAGE custom — Item/Outfit media switcher for collection grid.
// Sister of c-grid-view.js. Toggles `media-mode="item|outfit"` on the
// grid container; CSS in enrage-overrides.liquid swaps primary <-> secondary
// product card image based on the attribute. Persisted in localStorage,
// re-applied when facets refresh the grid via AJAX.

class MediaModeController extends HTMLElement {
    constructor() {
        super();
        this.grid = null;
        this.buttons = null;
        this.observer = null;
        this.isInitialized = false;
    }

    connectedCallback() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup());
        } else {
            this.setup();
        }
    }

    disconnectedCallback() {
        this.observer?.disconnect();
    }

    setup() {
        this.grid = document.getElementById('ajaxContainer');
        this.buttons = this.querySelectorAll('button[data-mode]');
        if (!this.grid || !this.buttons.length) {
            // Grid may render slightly later; retry once.
            setTimeout(() => this.setup(), 100);
            return;
        }
        if (this.isInitialized) return;

        const saved = localStorage.getItem('mediaMode') || 'item';
        this.apply(saved);

        this.buttons.forEach(b => b.addEventListener('click', (e) => {
            e.preventDefault();
            this.apply(b.dataset.mode);
            localStorage.setItem('mediaMode', b.dataset.mode);
        }));

        // Re-apply after facets / pagination AJAX swap the grid
        this.observer = new MutationObserver(() => {
            const newGrid = document.getElementById('ajaxContainer');
            if (newGrid && newGrid !== this.grid) {
                this.grid = newGrid;
                this.apply(localStorage.getItem('mediaMode') || 'item');
            }
        });
        this.observer.observe(
            document.querySelector('[data-facets-form-content]') || document.body,
            { childList: true, subtree: true }
        );

        this.isInitialized = true;
    }

    apply(mode) {
        if (mode !== 'item' && mode !== 'outfit') mode = 'item';
        if (this.grid) this.grid.setAttribute('media-mode', mode);
        this.buttons?.forEach(b => b.classList.toggle('active', b.dataset.mode === mode));
    }
}

customElements.define('media-mode-controller', MediaModeController);
